import { 
    START_FILTERED_LOAD,
    END_FILTERED_LOAD
} from '../action-types';

const initialState = { loading: false };

export default function(state = initialState, action) {

    switch (action.type) {
        case START_FILTERED_LOAD: {

          return action.payload
        }   
        case END_FILTERED_LOAD: {

            return action.payload
          }           
        default: {
          return state;
        }
    }
}
